import Client from './KomodoClient';

// komodo TextTemplateController (api/texttemplate). Templates resolve company override → merchant
// override → system default; `deptCode` = '' is the merchant scope. The query key must always be
// present (an absent key falls back to the BranchId header on the server).
const enc = encodeURIComponent;

const listAll = (deptCode) =>
	Client.get('/api/texttemplate', { deptCode: deptCode || '' });
const listByType = (templateType, deptCode) =>
	Client.get(`/api/texttemplate/query-list/${Number(templateType)}`, {
		deptCode: deptCode || '',
	});
const get = (templateCode) =>
	Client.get(`/api/texttemplate/${enc(templateCode)}`);
// Upsert on (deptCode, identityCode).
const create = (dto) => Client.post('/api/texttemplate', dto);
// The row's deptCode cannot change through PUT.
const update = (templateCode, dto) =>
	Client.put(`/api/texttemplate/${enc(templateCode)}`, dto);

export default { listAll, listByType, get, create, update };
